module.exports = __webpack_public_path__ + "img/Users.b47af5af.svg";